import Model from 'core/model/Model';

class McpServerModel extends Model {
  get urlRoot() {
    return '/api/ui/ai/mcp-servers';
  }
}

export default McpServerModel;
